
import ImageMeta from "@/mixins/imageMeta.js";
import FireIcon from "~/static/icons/fire.svg?inline";

export default {
  name: "PostOverviewItem",
  props: {
    post: Object,
  },
  mixins: [ImageMeta],
  components: {FireIcon},
  computed: {
    thumbnailAttributes() {
      return this.getAttribute(this.post, 'attributes.thumbnail.data.attributes');
    }
  },
  data() {
    return {
      isActive: false
    };
  },
  mounted() {
    this.initAnimation();
  },
  methods: {
    initAnimation() {
      if (this.$refs.link && this.$refs.link.$el) {
        this.$refs.link.$el.addEventListener('mouseenter', this.zoomIn);
        this.$refs.link.$el.addEventListener('touchstart', this.zoomIn);
        this.$refs.link.$el.addEventListener('mouseleave', this.zoomOut);
        this.$refs.link.$el.addEventListener('touchend', this.zoomOut);
      }
    },
    zoomIn() {
      const image = this.$refs.link.$el.querySelector('img');

      this.isActive = true;
      this.$anime.remove(image);
      this.$anime({
        targets: image,
        scale: 1.1,
        duration: 2000,
        easing: 'cubicBezier(0.2, 1, 0.36, 1)'
      });
    },
    zoomOut() {
      if (!this.$refs.link) return;
      const image = this.$refs.link.$el.querySelector('img');

      this.isActive = false;
      this.$anime.remove(image);
      this.$anime({
        targets: image,
        scale: 1,
        duration: 700,
        easing: 'easeOutExpo'
      });
    }
  },
}
